/** Paleta alinhada com `CATEGORY_COLOR_PALETTE` no backend. */
export const INCOME_SOURCE_COLOR_PALETTE = [
  '#7C9E6F',
  '#D4A574',
  '#6B8FA8',
  '#C97B84',
  '#9B8BB8',
  '#E8A54B',
  '#5BA3A3',
  '#B87DA6',
  '#8B9A6B',
  '#D97C5E',
  '#6C8EBF',
  '#A67C52',
];

export function pickNextIncomeSourceColor(existingSources = []) {
  const used = new Set(
    (existingSources || [])
      .map((s) => s?.color)
      .filter((c) => c && String(c).trim()),
  );
  const available = INCOME_SOURCE_COLOR_PALETTE.find((c) => !used.has(c));
  if (available) return available;
  const count = Array.isArray(existingSources) ? existingSources.length : 0;
  return INCOME_SOURCE_COLOR_PALETTE[count % INCOME_SOURCE_COLOR_PALETTE.length];
}
